import {
  vwebp,
} from '@didi/mfe-global-vue-directives'
import Vue from 'vue'
import DOMPurify from 'dompurify'
import vfilter from './filter-directive'
import vscrollBottom from './scroll-bottom-directive'

// 骨架指令
Vue.use(vwebp)
Vue.use(vfilter)
Vue.use(vscrollBottom)
Vue.directive('purifyHtml', {
  bind: function(el: HTMLElement, binding: any) {
    // 使用 DOMPurify 净化 HTML
    el.innerHTML = DOMPurify.sanitize(binding.value);
  },
  update: function(el, binding) {
    // 仅当值变化时更新
    if (binding.value !== binding.oldValue) {
      el.innerHTML = DOMPurify.sanitize(binding.value);
    }
  }
});
